module.exports = __webpack_public_path__ + "media/images/facebook-7b970ce00e3ade9b33d4e2941ac36c5c.svg";